import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import styled, { keyframes } from 'styled-components';

export const StepTabContainer = styled.div<{ $isActive: boolean }>`
	width: 100%;
	padding: 1rem 1rem 1rem;
	height: 100%;
	border-radius: 0.25rem;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	border: 1px solid
		${({ $isActive, theme }) => ($isActive ? theme.color.blue[500] : theme.color.greys[200])};
	background: ${({ $isActive, theme }) => ($isActive ? theme.color.blue[10] : 'transparent')};
	opacity: ${({ $isActive }) => ($isActive ? 1 : 0.5)};
	color: ${({ theme }) => theme.v2.color.neutral[300]};
	&:hover {
		cursor: pointer;
	}
	transition:
		border 0.3s ease,
		background 0.3s ease,
		opacity 0.3s ease;
`;

const popAnimation = keyframes`
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  50% {
    transform: scale(1.4);
    opacity: 1;
  }
  70% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
    opacity: 0.5;
  }
`;

export const AnimatedStyledIcon = styled(Icon)`
	animation: ${popAnimation} 0.6s cubic-bezier(0.22, 1, 0.36, 1); /* smooth bounce */
	animation-delay: 0.7ms;
	animation-fill-mode: backwards; /* So it stays invisible until animation starts */
`;

export const Header = styled.h6`
	color: ${(props) => props.theme.v2.color.neutral[1100]};
	font-variant-numeric: lining-nums tabular-nums;

	font-family: Inter;
	font-size: 0.875rem;
	font-style: normal;
	font-weight: 600;
	line-height: 1.25rem;
`;

export const SubHeader = styled.div`
	color: ${({ theme }) => theme.color.greys[600]};
	font-variant-numeric: lining-nums tabular-nums;

	font-family: Inter;
	font-size: 0.875rem;
	font-style: normal;
	font-weight: 400;
	line-height: 1.25rem;
`;

export const TextContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	flex: 1 0 0;
`;
